import * as React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, BREAKPOINTS } from '../styles';

const LinkStyling = css`
  &:focus {
    background: ${COLORS.primary_500};
    outline: none;
  }
  &:focus-within {
    box-shadow: 0px 0px 8px ${COLORS.primary}, 0px 4px 12px rgba(46, 127, 161, 0.25);
  }
`;

const ImageStyling = css`
  &:hover {
    background-color: ${COLORS.primary_700};
  }

  &:active {
    background: ${COLORS.primary_800};
  }
`;

const AvatarLink = styled.div<{ size: number; useInteractionStyling: boolean }>`
  text-decoration: none;

  ${props => (props.useInteractionStyling ? LinkStyling : '')};
  &:focus {
    outline: none;
  }
  &:focus-within {
    border-radius: ${props => (props.useInteractionStyling ? `${props.size ? props.size : 48}px` : '')};
  }
`;

const AvatarImage = styled.div<{ size: number; color: string; useInteractionStyling: boolean }>`
  background-color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => (props.size ? props.size : 48)}px;
  height: ${props => (props.size ? props.size : 48)}px;
  width: ${props => (props.size ? props.size : 48)}px;
  cursor: pointer;

  ${props => (props.useInteractionStyling ? ImageStyling : '')};
`;

const AvatarLetter = styled.div<{ size: number }>`
  font-size: ${props => props.size / 2 - 2}px;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  line-height: ${props => (props.size ? props.size : 48)}px;
`;

export const AvatarContainer = styled.div<{ hideOnLowWidth?: boolean; inMobileMenu?: boolean; hidePadding?: boolean }>`
  flex-direction: column;
  align-self: center;
  margin-right: ${props => (props.inMobileMenu ? '6px' : '8px')};
  margin-left: ${props => (props.inMobileMenu ? '0' : 'auto')};
  display: ${props => (props.hideOnLowWidth ? 'none' : 'flex')};

  ${BREAKPOINTS.MEDIUM} {
    display: flex;
    ${props => !props.hidePadding ? 'padding: 6px;' : ''};
  }
`;

interface AvatarProps {
  firstName: string;
  lastName: string;
  size: number;
  color: string;
  profileMenuLink: string;
  useInteractionStyling?: boolean;
}

const Avatar = ({ firstName, lastName, size, color, useInteractionStyling = true }: AvatarProps) => {
  return (
    <AvatarLink size={size} tabIndex={0} useInteractionStyling={useInteractionStyling} onMouseDown={(e: any) => e.preventDefault()}>
      <AvatarImage size={size} color={color} useInteractionStyling={useInteractionStyling}>
        <AvatarLetter data-hj-suppress size={size}>
          {firstName[0]}
          {lastName[0]}
        </AvatarLetter>
      </AvatarImage>
    </AvatarLink>
  );
};

export default Avatar;
